<template>
  <div id="introduce-guideline">
    <section ref="Giới Thiệu" id="Giới Thiệu">
      <h4>JSON for Developer</h4>
      <div class="content-introduce pa-2">
        <p>
          Để phù hợp cho các hệ thống khác nhau,với nhu cầu khác nhau của người
          dùng,AI Editor cho phép trích xuất data dưới dạng JSON: <br />
          JSON Data AI editor có 2 loại : <br />
          - <b>Có box(position cụ thể của object trên content)</b><br />
          -<b> Không có box(chỉ trả về khoảng thời gian)</b>
          <br />
          Dưới đây là hình ảnh mô tả về JSON không có box
          <img
            class="rounded-sm mt-2"
            width="100%"
            src="../../assets/tutorial/ai-editor/json-description.png"
          />
          <br />
        </p>

        <p>Dưới đây là hình ảnh mô tả về JSON có box</p>
        <img
          class="rounded-sm mt-2"
          width="100%"
          src="../../assets/tutorial/ai-editor/json-description-box.png"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert } from "@mdi/js";
export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      currentSectionId: "",
    };
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.myAnchorTilte = entry.target.id;
        }
      });
    }, options);

    Object.values(this.$refs).forEach((ref) => observer.observe(ref));

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
    window.scrollTo(0, 2);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
  },
};
</script>

<style lang="scss">
#Introduce {
  ul.circle {
    list-style-type: circle;
  }
  .content-introduce {
    padding: 10px;
    background-color: #f9f9f9;
  }
}
</style>
